import api from "../api";

const BASE = process.env.REACT_APP_MODEL_ENDPOINT;

// ------------------------------------------------------------------ //
// User API                                                             //
// ------------------------------------------------------------------ //

const createTicket = (subject, body, files = []) => {
  const form = new FormData();
  form.append("subject", subject);
  form.append("body", body);
  files.forEach((f) => form.append("files", f));
  return api.post("/support/tickets", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getTickets = () => api.get("/support/tickets");

const getTicket = (ticketId) => api.get(`/support/tickets/${ticketId}`);

const postMessage = (ticketId, body, files = []) => {
  const form = new FormData();
  form.append("body", body);
  files.forEach((f) => form.append("files", f));
  return api.post(`/support/tickets/${ticketId}/messages`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getAttachmentUrl = (ticketId, attachmentId) =>
  `${BASE}/support/tickets/${ticketId}/attachments/${attachmentId}`;

// ------------------------------------------------------------------ //
// Admin API (superadmin only)                                          //
// ------------------------------------------------------------------ //

const adminGetTickets = (status = null) =>
  api.get("/support/admin/tickets", { params: status ? { status } : {} });

const adminGetTicket = (ticketId) =>
  api.get(`/support/admin/tickets/${ticketId}`);

const adminPostMessage = (ticketId, body, files = []) => {
  const form = new FormData();
  form.append("body", body);
  files.forEach((f) => form.append("files", f));
  return api.post(`/support/admin/tickets/${ticketId}/messages`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const adminUpdateStatus = (ticketId, status) =>
  api.patch(`/support/admin/tickets/${ticketId}/status`, { status });

const getUnreadCount = () => api.get("/support/unread_count");

const markRead = (ticketId) => api.patch(`/support/tickets/${ticketId}/mark_read`);

const adminGetUnreadCount = () => api.get("/support/admin/unread_count");

const adminMarkRead = (ticketId) => api.patch(`/support/admin/tickets/${ticketId}/mark_read`);

export const supportApi = {
  createTicket,
  getTickets,
  getTicket,
  postMessage,
  getAttachmentUrl,
  getUnreadCount,
  markRead,
  adminGetTickets,
  adminGetTicket,
  adminPostMessage,
  adminUpdateStatus,
  adminGetUnreadCount,
  adminMarkRead,
};
